import React from "react";
import classes from "./Footer.module.scss";
import { Link } from "react-router-dom";
import { AiOutlineInstagram, AiOutlineFacebook } from "react-icons/ai";
import { FiTwitter, FiYoutube } from "react-icons/fi";
export default function Footer() {
  return (
    <div className={classes.footer}>
      {/* Footer Top Started */}
      <div className={classes.footerTop}>
        <div className={classes.footerTopLeft}>
          <div className={classes.footerTopLeftTop}>
            <Link to='/'>
              <p> Money Magic </p>
            </Link>
          </div>
          <div className={classes.footerTopLeftMiddle}>
            <p>
              We Provide Financial Education To Everyone And Help Them Escape
              Inflation
            </p>
          </div>

          {/* Social Media Icons */}
          <div className={classes.footerTopLeftBottom}>
            <h4>Follow Us On</h4>
            <span className={classes.footerLogoYouTube}>
              <a href='#youtube'>
                <FiYoutube />
              </a>
            </span>
            <span className={classes.footerLogoInstagram}>
              <a href='https://api.instagram.com/v1/users/userID?client_id=YourClientID'>
                <AiOutlineInstagram />
              </a>
            </span>
            <span className={classes.footerLogoTwitter}>
              <a href='http://twitter.com/IsabelleOC/statuses/'>
                <FiTwitter />
              </a>
            </span>
            <span className={classes.footerLogoFacebook}>
              <a href='#facebook'>
                <AiOutlineFacebook />
              </a>
            </span>
          </div>
        </div>

        {/* Footer Middle Start */}
        <div className={classes.footerTopCenter}>
          <h3>Explore</h3>
          <div className={classes.footerTopCenterList}>
            <ul>
              <li>
                <Link to='/calculators'>Calculators</Link>
              </li>
              <li>
                <Link tp='/blogs'>Blogs</Link>
              </li>
              <li>
                <Link to='/modules'>Modules</Link>
              </li>
              <li>
                <Link to='/stockAnalysis'>Stock Analysis</Link>
              </li>
              <li>
                <Link to='/stockComparison'>Stock Comparison</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className={classes.footerTopRight}>
          <h3>Resources</h3>
          <ul>
            <li>
              <Link to='/aboutus'>About Us</Link>
            </li>
            <li>
              <Link to='/contactus'>Contact Us</Link>
            </li>
            <li>
              <Link to='/faq'>FAQ </Link>
            </li>
          </ul>
        </div>
      </div>
      {/* Footer Top Ends */}

      {/* Footer Bottom Started */}
      <hr />
      <div className={classes.footerBottom}>
        <p>Copyright © 2021 Money Magic</p>
      </div>
    </div>
  );
}
